// Regras de escopo por loja para as listagens (pedidos e clientes).
//
// Um usuário é restrito à própria loja quando:
//   - não é admin (vendedor comum), OU
//   - é Gerente (mesmo sendo admin, o Gerente enxerga apenas a própria loja).
//
// Sem storeId não há como escopar, então nesse caso não restringe.
export function isStoreScoped(user) {
  if (!user) return false;
  const isGerente = user.position === "Gerente";
  return (!user.isAdmin || isGerente) && !!user.storeId;
}

// Filtro de storeId para o endpoint de clientes (GET /customers -> allFilters).
export function storeScopeFilters(user) {
  return isStoreScoped(user)
    ? [{ field: "storeId", value: user.storeId }]
    : [];
}

// Escopo de loja para o endpoint de pedidos (POST /orders/find -> stories).
export function storeScopeOrders(user) {
  return isStoreScoped(user) ? { stories: [user.storeId] } : {};
}

// Lista de lojas (`stories`) efetiva para as queries dos indicadores.
//
// Precedência:
//   1. Seleção explícita do usuário no seletor de lojas (storeIds).
//   2. Usuário escopado por loja (Gerente / vendedor) → sempre a própria loja,
//      mesmo antes do seletor ser travado pelo getStories (evita o vazamento
//      de "todas as lojas" no primeiro carregamento).
//   3. Admin comum sem seleção → [] (backend interpreta como todas as lojas).
export function effectiveStories(user, storeIds = []) {
  if (Array.isArray(storeIds) && storeIds.length > 0) return storeIds;
  if (isStoreScoped(user)) return [user.storeId];
  return [];
}
